import { createFileRoute } from "@tanstack/react-router";

import { ComingSoonPage } from "@/components/Pages";

export const Route = createFileRoute("/coming-soon")({
  component: ComingSoonPage,
});
